import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import CustomDestinationsImage from './CustomDestinationsImages'

const copy = {
  overline: `Extend Segment with custom capabilities`,
  heading: `Enrich, transform, and mask data with code`,
  description: `Insert code to enrich data with context from profiles and third-party sources, filter events to ensure data quality, and even mask sensitive data to support compliance. `,
}

export const CustomDestinations = () => {
  return (
    <Wrapper>
      <SectionComponent variant="2Col" copyVariant="narrow" reverse={true}>
        <Section.Copy alignSelf="center">
          <CopyTextBase>
            <CopyText.Overline>{copy.overline}</CopyText.Overline>
            <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
            <CopyText.Description tag="h2">{copy.description}</CopyText.Description>
          </CopyTextBase>
        </Section.Copy>
        <Section.Contents>
          <CustomDestinationsImage />
        </Section.Contents>
      </SectionComponent>
    </Wrapper>
  )
}

const SectionComponent = styled(SectionBase)`
  overflow-x: visible;
  justify-content: center;
  ${Section.Wrapper} {
    padding-top: 80px;
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      padding-top: 40px;
      padding-bottom: 40px;
    }
  }
`

const Wrapper = styled.div``

export default CustomDestinations
